import React from 'react';
import Helper from "../../helper/Common_Helper"

function SelectLang({ setIsModalOpen, setSelectedLanguage,langSelected }) {

  const handleLanguageSelection = (selectedLanguageName) => {
    const selectedLang = Helper.languages.find(lang => lang.name === selectedLanguageName);
    setIsModalOpen(true); // Open the modal
    setSelectedLanguage(selectedLang);
    
    if (selectedLang) {
      localStorage.setItem('langCode', selectedLang.langCode);
      localStorage.setItem('voice', selectedLang.voice);
    }
  };

  return (
    <div className='slctalfertDivnew'>
      
      <select className='form-control langSelected' id="langSelect" onChange={(e) => handleLanguageSelection(e.target.value)}>
      <option  value={langSelected}>{langSelected}</option>
        {Helper.languages.map((lang, index) => (
          <>
          {
            langSelected !== lang.name && <option key={index} value={lang.name}>{lang.name}</option>
          }
         
          
          
          </>
        ))}
      </select>
    </div>
  );
}

export default SelectLang;
